import { useDispatch } from 'react-redux';

import { api } from '../../config/api';
import { deleteDraftApi as generatedDeleteDraftApi } from '../generated/quickDraft/deleteDraft';

import type { DeleteDraftApiArg as GeneratedDeleteDraftApiArg } from '../generated/types';

type DeleteDraftApiArg = GeneratedDeleteDraftApiArg & {
  date: string;
};

const deleteDraftApi = generatedDeleteDraftApi.enhanceEndpoints({
  endpoints: {
    deleteDraft: {
      invalidatesTags: (_result, _error, { id }) => [{ id, type: 'Drafts' as const }],
    },
  },
});

export const useDeleteDraftMutation = () => {
  const dispatch = useDispatch();
  const [deleteDraft, state] = deleteDraftApi.useDeleteDraftMutation();

  const deleteDraftWithDate = ({ date, ...arg }: DeleteDraftApiArg) => {
    const result = deleteDraft(arg);

    return Object.assign(result, {
      unwrap: async () => {
        const data = await result.unwrap();

        dispatch(
          api.util.invalidateTags([
            { id: date, type: 'Drafts' as const },
            { id: date, type: 'Slots' as const },
          ]),
        );

        return data;
      },
    });
  };

  return [deleteDraftWithDate, state] as const;
};
